import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ReusableSnackbarComponent } from '../../shared/components/snackbar/snackbar.component';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  constructor(private _snackBar: MatSnackBar) {}

  open(data: { message: string; type: 'success' | 'error' }) {
    const config: MatSnackBarConfig = {
      data,
      duration: 5000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: [
        data.type === 'success' ? 'success-snackbar' : 'error-snackbar',
      ],
    };
    this._snackBar.openFromComponent(ReusableSnackbarComponent, config);
  }
}
